/*
 * @Author: sunxiaohui
 */
import { writable } from 'svelte/store'
export const notification = writable()